import DateFieldFormValue from "../ReusableFormValues/DateFieldFormValue";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { collectionStatusTypesArray } from "./constants";

interface Props {
  readonly: boolean;
}

const KYCChecklistFormValues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={collectionStatusTypesArray}
        placeholder="Select a collection status"
        name="collectionStatus"
        label="Collection status"
      />
      <DateFieldFormValue
        name="asOfDate"
        label="As of date"
        readonly={readonly}
        maxDate={new Date()}
      />
    </>
  );
};

export default KYCChecklistFormValues;
